<template>
    <div class="container">
        <div class="section-space-25"></div>
        <div class="section-header-title">Offers</div>
        <div class="section-space-25"></div>

        <div class="row" style="row-gap: 10px;">
            <!-- Loader -->
            <div class="col-12" v-if="isLoading">
                <component-content-loader />
            </div>

            <!-- Offer Cards -->
            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 evenSpacing" v-for="(offer, index) in offers"
                :key="index">
                <div class="new-card-section position-relative">
                    <div class="offer-listing-card">
                        <!-- Offer Image -->
                        <div class="offer-card-img-box" @click="() =>
                            $router.push({
                                name: 'Offer Detail',
                                params: { offer_id: offer.id }
                            })">
                            <img v-lazy="offer.image_path ? IMAGE_URL + offer.image_path : null"
                                class="lazy-image img-fluid" alt="Offer Image" />
                        </div>

                        <!-- Offer Content -->
                        <div class="offer-content">
                            <div class="offer-title" :title="offer.offer_name">
                                <span>{{ offer.offer_name }}</span>
                            </div>

                            <div class="mt-2">
                                <router-link class="btn btn-primary w-100 font-weight-bold" to @click.native="
                                    () =>
                                        $router.push({
                                            name: 'Offer Detail',
                                            params: { offer_id: offer.id }
                                        })
                                ">
                                    View Details
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div class="col-12" v-if="!isLoading && offers.length === 0">
                <div class="text-center py-5">No Offers Found</div>
            </div>
        </div>
        <section>
            <div>
                <div class="section-space-25"></div>
            </div>
        </section>
    </div>
</template>

<script>
import OfferService from "@/apiServices/OfferService";
import { IMAGEURL } from "@/config";

export default {
    data() {
        return {
            IMAGE_URL: IMAGEURL,
            offers: [],
            isLoading: false,
        };
    },
    beforeMount() {
        this.getOffers();
    },
    methods: {
        async getOffers() {
            this.isLoading = true;
            try {
                const response = await OfferService.GetOffers();
                if (response.data.status) {
                    this.offers = response.data.data;
                }
            } catch (err) {
                console.log("Error in getting offers", err);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style scoped>
.offer-card-img-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-dark-2);
  width: 100%;
  aspect-ratio: 3 / 4; /* keeps consistent image area without fixed height */
  overflow: hidden;
}

.offer-card-img-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* shows full image without cropping */
  transition: transform 0.3s ease;
}

.offer-listing-card:hover .offer-card-img-box img {
  transform: scale(1.03);
}

.offer-content {
  padding: 10px;
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.evenSpacing {
  display: flex;
}

.new-card-section {
  display: flex;
  flex: 1;
}

.offer-listing-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background: var(--bg-dark-2);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/offers.vue